import { GlobeScene } from "@/components/three/GlobeScene";
import { Hud } from "@/components/Hud";
import { Nav } from "@/components/Nav";
import { Hero } from "@/sections/Hero";
import { Capabilities } from "@/sections/Capabilities";
import { Sovereign } from "@/sections/Sovereign";
import { Products } from "@/sections/Products";
import { Contact } from "@/sections/Contact";
import { Footer } from "@/sections/Footer";

export default function App() {
  return (
    <div className="relative">
      {/* Fixed ambient ops globe behind the hero */}
      <div className="fixed inset-0 z-0">
        <GlobeScene className="!h-full !w-full" />
      </div>
      {/* Tactical grid + vignette over the globe (keeps hero text legible) */}
      <div className="hud-grid pointer-events-none fixed inset-0 z-0 opacity-40" />
      <div
        className="pointer-events-none fixed inset-0 z-0"
        style={{
          background:
            "linear-gradient(to right, rgba(5,7,14,0.92) 0%, rgba(5,7,14,0.35) 45%, rgba(5,7,14,0) 75%), radial-gradient(130% 130% at 75% 35%, transparent 0%, rgba(5,7,14,0.45) 50%, rgba(5,7,14,0.96) 100%)",
        }}
      />

      <Hud />
      <Nav />

      <main className="relative z-10">
        <Hero />

        {/* Opaque field slides over the globe past the hero */}
        <div className="relative bg-ink-950">
          <div className="pointer-events-none absolute inset-x-0 -top-32 h-32 bg-gradient-to-b from-transparent to-ink-950" />
          <Capabilities />
          <Sovereign />
          <Products />
          <Contact />
          <Footer />
        </div>
      </main>
    </div>
  );
}
